import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { ProductService } from "app/products/service/product.service";

@Component({
  selector: 'product-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.css']
})
export class LeadFormComponent implements OnInit {
  portalInfo: any;
  subcategory: any;
  total_question_set;
  limit=4;
  question_answer: { [id: string]: any; } = {}; 
  heading=false;
  question_form;
  my_time;
  questions;
  active_group_id=0;
 user_time(event){
    this.my_time=event;
 }
   fakeArray = new Array(31);
   month: any[];
   year:any[]=[];
   complexForm : FormGroup;
   success_message:boolean=true;
   choosen_products:any;
   external_app_link_pay;
   external_app_link_early;
   show_form;
   datepickerOpts = {
      startDate: new Date(),
      autoclose: true,
      todayBtn: 'linked',
      todayHighlight: true,
      assumeNearbyYear: true,
  }
   constructor(
      fb: FormBuilder,
      private productService:ProductService,
      private loanOfferService:LoanOfferGenService,

      ) {
      if(localStorage.getItem('page-questions')){
     
        this.questions=JSON.parse(localStorage.getItem('page-questions'));
        this.total_question_set=Math.round(this.questions.length/this.limit);
        this.question_form=false;
        this.show_form=true;
        }else{
          this.show_form=false;
          this.question_form=true;
        }

      if(localStorage.getItem('choosen_product')){
         this.choosen_products=JSON.parse(localStorage.getItem('choosen_product'));
         this.subcategory=this.choosen_products.sub_category;
      }
      if(localStorage.getItem('portalInfo')){
        this.portalInfo=JSON.parse(localStorage.getItem('portalInfo'));
        this.external_app_link_pay=this.portalInfo.paysense_link;
        this.external_app_link_early=this.portalInfo.early_salary_link;
     }
        if(this.questions.length==0){
          this.show_form=false;
        }
      let i=new Date().getFullYear();
      let a;
      for(a=i-60;a<=i;a++){
        this.year.push(a);
      }
      let f_now   = new Date();
      let f_date  = new Date(f_now.getFullYear(),f_now.getMonth(),f_now.getDate());
      this.month=['Jan','Feb','Mar','Apr','May','Jun','July','Aug','Sep','Oct','Nov','Dec']
      this.complexForm = fb.group({
        'name': [loanOfferService.getLocalLeadContactData('name'), Validators.compose([Validators.required, Validators.minLength(3)])],
        'email': [loanOfferService.getLocalLeadContactData('email'), Validators.compose([Validators.required, Validators.email])],
        'contact_number' : [loanOfferService.getLocalLeadContactData('contact_number'), Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
        'contact_at': [f_date],
      
      })
    }
  next(id){
 
      if(id!=null&&id<=this.total_question_set-1){
        this.active_group_id=id+1;
      }
      if(id==this.total_question_set-1){
        this.show_form=false;
        this.question_form=true;
      }
    
  }
  back(id){
 
    if(id!=null){
      this.active_group_id=id-1;
    }else{
      this.show_form=true;
      this.question_form=false; 
    }
  
  }
  answer(q,a){
   this.question_answer[q] = a;
    console.log(this.question_answer);
  }

 

  ngOnInit() {
  }
  
  submitForm(value){
    this.heading=true; 
    console.log(this.question_answer);
    let month;
    let contact;
    this.success_message = false;

    if(!value.contact_at){
      value.contact_at = Date.now();
    }
    month=parseInt(value.contact_at.getMonth())+1;
    contact= value.contact_at.getDate()+'-'+month+'-'+value.contact_at.getFullYear();
    value.contact_me_at='date:'+contact+',time:'+this.my_time;
    for (var key in this.question_answer) {
      if (this.question_answer.hasOwnProperty(key)) {
       value[key]=this.question_answer[key];
      }
    }
  
    delete value.contact_at;
   
   
    localStorage.setItem('lead_contact',JSON.stringify(value));
    console.log('lead_contact',JSON.stringify(value));
    this.productService.sentLeadInformation();
    this.show_form=true;
    
  }
  round(a){
    return this.active_group_id=Math.floor(a);
  }
  getGroupId(i){
    return Math.floor(i/this.limit);
  }
  back_from_main_form(){
    this.show_form=true;
    this.question_form=false;
    this.active_group_id=this.active_group_id-1;
  }
 
}


// WEBPACK FOOTER //
// ./src/app/products/lead-form/lead-form.component.ts